import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Site, RouterContextProvider } from "tabler-react";
import { auth } from '../services/firebase';
import { useGlobalState, setName, setRole } from '../services/state';

function PrivatePage(props) {
  const [headerProps] = useGlobalState('headerProps');
  const [navProps] = useGlobalState('navProps');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    auth().onAuthStateChanged(user => {
      user.getIdTokenResult().then(result => {
        setName(user.displayName);

        setVisible(true);
      });
    })
  }, []);

  return (
      visible ?
      <Site.Wrapper
        headerProps={ headerProps }
        navProps={ navProps }
        routerContextComponentType={withRouter(RouterContextProvider)}
      >
        {props.children}
      </Site.Wrapper> : null
  );
}

export default PrivatePage;